import {useContext, useEffect, useState} from "react";
import axios from "axios";
import Design1 from "./design-1";
import Design2 from "./design-2";
import useApplyUserDefinedListOverrides from "../../hooks/use-user-defined-list-sort";
import {WebsiteContext} from "../../index";
import {filterItems, makeItems} from "../../utils/utils";

export default function GalleryBlock(props) {
    let DesignBlock;
    const context = useContext(WebsiteContext);
    const isCollection = props?.values?.source === "collection";
    const isBuilder = context.builder;
    const hasItems = props?.values?.items?.length > 0;

    const [items, setItems] = useState(() =>
        isCollection && !isBuilder && !hasItems && props?.values?.placeholderImage
            ? makeItems([{image: props.values.placeholderImage}], {image: "image"})
            : props?.values?.items || []
    );

    const [state, setState] = useState(() =>
        isCollection && !isBuilder && !hasItems
            ? props?.values?.emptyState
            : undefined
    );

    const displayItems = filterItems(isCollection ? items : props.values.items);

    const values = useApplyUserDefinedListOverrides({
        ...props,
        items: displayItems
    });

    useEffect(() => {
        const cancelToken = axios.CancelToken.source();
        if (isBuilder && isCollection) {
            axios
                .post(`/api/v2/website/schema`, {...props?.values}, {
                    headers: {"X-Preview-Domain": `${location.protocol}//${context?.website?.previewDomain}`},
                    cancelToken: cancelToken.token,
                })
                .then(({data}) => {
                    if (data?.items?.length > 0) {
                        setItems(filterItems(data?.items))
                        setState(null)
                    } else {
                        setItems(makeItems([{image: props.values.placeholderImage}], {image: "image"}));
                        setState(props?.values?.emptyState);
                    }
                })
                .catch((err) => {
                    if (!axios.isCancel(err)) console.error("Failed to fetch schema data:", err)
                })
        }
        else if(!isCollection) setItems(props?.values?.items || [])
        return () => cancelToken.cancel();
    }, [props?.values]);

    // Render based on design prop
    switch (props.values?.design) {
        case 0:
            DesignBlock = Design1
            break;
        case 1:
            DesignBlock = Design2
            break;
        default:
            DesignBlock = Design1
    }
    return (
        <DesignBlock {...props} values={values} state={state}/>
    )
}